<!--
 * @Author: awu
 * @Date: 2020-11-12 23:15:13
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 21:07:01
 * @Description: file content
-->
<template>
    <div class="product">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
            <swiper-slide
                style="position:relative"
                v-for="(item, index) in swiperSlide"
                :key="index"
                :class="{
                    over: overIndex == index,
                    noover: overIndex == !index
                }"
            >
                <div class="box" @click.stop="toDetail(item)" @mouseenter="mouseOver($event, index)" @mouseleave="mouseOut($event)">
                    <div class="boxTop">
                        <img v-show="item.is_store == 1" @click.stop="cancelCollect(item)" class="collect" src="../../assets/area/iscol.png" alt="" />
                        <img v-show="item.is_store == 0" @click.stop="collect(item)" class="collect" src="../../assets/area/nocol.png" alt="" />
                        <img class="productImg" :src="item.product.cn.main_image[0].url" alt="" />
                    </div>
                    <div class="boxBot">{{ item.product.cn.name }}</div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" @click="prev()" slot="button-prev">
            <img v-show="leftArrowFlag" src="../../assets/left.png" alt="" />
            <img v-show="!leftArrowFlag" src="../../assets/noLeft.png" alt="" />
        </div>
        <div class="swiper-button-next" @click="next()" slot="button-next">
            <img v-show="rightArrowFlag" src="../../assets/right.png" alt="" />
            <img v-show="!rightArrowFlag" src="../../assets/noRight.png" alt="" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
// import { exhibition_id } from "@/utils/exhibitId";
import Lockr from "lockr";
export default {
    data() {
        return {
            swiperOptions: {
                //设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    disabledClass: "my-button-disabled"
                },
                loop: false,
                slidesPerView: 3,
                lidesPerGroup: 2
            },
            overIndex: -1,
            slideNum: 3,
            leftArrowFlag: false,
            rightArrowFlag: false,
            swiperSlide: [],
            exhibition_id: ''
        };
    },
    mounted() {
        this.exhibition_id = this.$route.query.exhibition_id
        this.getExhibitionProduct();
    },
    methods: {
        backHome() {
            this.$root.$emit("close");
            this.$emit("cancel", 3);
        },
        prev() {
            this.swiper.slidePrev();
            this.slideNum--;
            if (this.slideNum <= 3) {
                this.slideNum = 3;
            }
        },
        next() {
            this.swiper.slideNext();
            this.slideNum++;
            if (this.slideNum >= this.swiperSlide.length) {
                this.slideNum = this.swiperSlide.length;
            }
        },
        mouseOver($e, index) {
            this.overIndex = index;
        },
        mouseOut($e) {
            this.overIndex = -1;
        },
        collect(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                setTimeout(()=>{
                    this.$router.push({
                        path: '/login'
                    },3600)
                })
                return
            }else{
                api.isCollectProduct({
                    exhibition_product_id: item.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$message.success("收藏成功");
                    }
                });
            }
        },
        cancelCollect(item) {
            api.noCollectProduct({
                exhibition_product_id: item.id
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    item.is_store = 0;
                    this.$message.success("取消收藏");
                }
            });
        },
        toDetail(item) {
            // this.$router.push({
            //     path: "/area/ztDetail/detail",
            //     query: {
            //         id:item.id,
            //         instance_id:Number(this.$route.query.instance_id),
            //         company_id:Number(this.$route.query.company_id),
            //     }
            // });
            // this.$root.$emit("close");
            Lockr.set("productId", item.id);
            this.$emit("cancel", 3);
            this.$emit("show", 7);
        },
        // 获取展台商品列表
        getExhibitionProduct() {
            api.getExhibitionProduct({
                exhibition_id: this.exhibition_id,
                company_id: this.$route.query.company_id
            }).then((res) => {
                if (res.res == 1) {
                    if (!res.list || !res.list.length) {
                        this.$message.info(this.$t("tips").noProduct);
                        return;
                    }
                    this.swiperSlide = res.list;
                }
            });
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        },
        ...mapState(["userInfo","language"]),
    },
    watch: {
        slideNum(value) {
            if (value <= 3) {
                this.leftArrowFlag = false;
            }
            this.leftArrowFlag = value <= 3 ? false : true;
            this.rightArrowFlag = value >= this.swiperSlide.length ? false : true;
        },
        swiperSlide(value) {
            if (value.length <= 3) {
                this.leftArrowFlag = false;
                this.rightArrowFlag = false;
            } else {
                this.leftArrowFlag = false;
                this.rightArrowFlag = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.product {
    width: 667px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 30px;
    box-sizing: border-box;
    padding: 53px 20px;
    .swiper {
        width: 600px;
        height: 230px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0px;
        .box {
            width: 160px;
            height: 187px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #ffffff;
            box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.3);
            border-radius: 5px;
            cursor: pointer;
            .boxTop {
                width: 100%;
                height: 153px;
                position: relative;
                .collect {
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    top: 7px;
                    right: 7px;
                    z-index: 2;
                }
                .productImg {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                }
            }
            .boxBot {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 100%;
                height: 34px;
                background: #ffffff;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #09468c;
                line-height: 34px;
                text-align: center;
            }
        }
        .over {
            transform: scale(1.1); //设置缩放比例
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -o-transform: scale(1.1);
            -moz-transform: scale(1.1);
            transition-duration: 0.2s;
            .boxBot {
                background: #09468c;
                color: #ffffff;
            }
        }
        .noover {
            transform: scale(1); //设置缩放比例
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            transition-duration: 0.2s;
        }
    }
    .my-button-disabled {
        opacity: 0.2;
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    cursor: pointer;
    border-radius: 50%;
    > img {
        width: 100%;
        height: 100%;
    }
}
.backHome:hover {
    background-color: #e8eef4;
}
</style>



// WEBPACK FOOTER //
// src/views/product/index.vue